// import Period from './Period';

export default {
  // component: Period,
  component: load(() => import(/* webpackChunkName: "Evaluation360-Period" */ './Period')),
  priority: 100,
  permissions: ["360EvaluationMenu/PeriodMenu"],
  name: app.translate('routes.home.evaluation-360.Period'),
  icon: 'camera-timer',
  drawer: true,
};
